import Tracking from "./tracking.service";
import Flow from "./flow.service";
// import Globals from "./globals";
import Helpers from "./helpers";
import Settings from "./settings";
import Storage from "./storage.service";
import CONSTANTS from "./constants.service";
import Numbers from "./number.service";
import { Experiences } from "../static/convertExperiencesObj";

var Events = {};

Events.getCategoryByArea = () => {
  let sheet_area = Events.getArea();
  if (
    sheet_area === "number/transfer" ||
    sheet_area === "number/transfer-terms"
  ) {
    sheet_area = "Transfer Number";
  }

  if (sheet_area === "residency") {
    sheet_area = "Resident Validation";
    let residency_info = Storage.get("is_resident", true);
    if (residency_info && residency_info === CONSTANTS.NON_RESIDENT) {
      sheet_area = "Pay and Collect";
    }
  }

  if (sheet_area === "plan-selection") {
    sheet_area = "Plan";
  }

  if (sheet_area === "payment") {
    sheet_area = "Review";
  }

  if (sheet_area === "login") {
    sheet_area = "Account";
  }

  return "Checkout " + sheet_area.replace("_", " ");
};

Events.getArea = () => {
  let route = Flow.getCurrentRoute() || "";
  return route.substring(1).replace("/", "_");
};

Events.getPrice = (plan = null) => {

  let product = Storage.get("selectedProduct");
  let amount = 0;
  if (!plan) {
    plan = Storage.get("saved_plan");
    if (plan && plan.product) {
      product = plan.product;
    }
  }

  if (product && plan) {
    if (product["ProductCategory"] === "PAYG") {
      let extraCharges = plan.PackagePrice.ExtraCharges;
      for (let charge of extraCharges) {
        if (charge["Name"] === "RechargeAmount") {
          amount = charge["Amount"];
          break;
        }
      }
    } else {
      if (plan.PackagePrice) {
        amount = plan.PackagePrice.NetPrice;
      }

    }
  }

  return amount;
};

Events.getPlanforTracking = (plan = null) => {
  let result = [];
  if (!plan) {
    plan = Storage.get("saved_plan");
  }
  if (plan) {
    for (let type of Settings.types_new_order) {
      let id = plan["vmo_subplans_ids_by_type"][type];
      if (id) {
        let val = plan["vmo_subplans"][id]["vmo_ValueFormatted"];
        result.push(val);
      }
    }
  }

  return result.join("|");
};

Events.getPlanTypeforTracking = (product = null) => {
  if (!product) {
    product = Storage.get("selectedProduct");
  }
  if (product) {
    if (product["ProductCategory"] === "PAYG") {
      return "PAYG";
    }
  }
  let saved_plan = Storage.get("saved_plan");
  if (saved_plan) {
    if (Helpers.isVipNumber(Helpers.getVanityLevel(saved_plan))) {
      return "VIP";
    }
  }
  return "CUS";
};

Events.getNumberTypeforTracking = (number) => {
  // <Vanity, eg: VIP, Random, Chosen, MNP>
  if (number.InTransferTo) {
    return "MNP";
  }

  if (Helpers.isVipNumber(Helpers.getVanityLevel(number))) {
    return "VIP";
  }

  if (Storage.get("number_booked_using_search")) {
    return "Chosen";
  }

  return "Random";
};

Events.initTracking = () => {
  Tracking.init();
};

// Events.clicks_on_summary_edit_plan = (copy) => {
//   let event_name = "Clicks on edit plan icon";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Plan Edit";
//   let eventLabel = Events.getPlanforTracking();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_summary_edit_number = (copy, number) => {
//   let event_name = "Clicks on edit number icon";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Edit";
//   let eventLabel = Events.getNumberTypeforTracking(number);

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_fb_login = () => {
//   let event_name = "Clicks on Facebook button";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Registration";
//   let eventLabel = "Facebook button clicked";
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);

// }

// Events.clicks_on_summary_confirm_product_change = (
//   new_prod,
//   old_prod,
//   copy
// ) => {
//   let event_name = "Clicks on summary confirm product change";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Commitment Selection";
//   let eventLabel = new_prod ? new_prod.CommitmentDuration : "";
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_summary_product_tab = (new_prod, old_prod, copy) => {
//   let event_name = "Clicks on summary commitment tab";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Commitment Selection";
//   let eventLabel = new_prod ? new_prod.CommitmentDuration : "";
  

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_summary_cancel_product_change = (new_prod, old_prod, copy) => {
//   let event_name = "Clicks on summary cancel product change";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Commitment Selection";
//   let eventLabel = new_prod ? new_prod.CommitmentDuration : "";
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_promo_code_field = () => {
//   let event_name = "Clicks on promo code field";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Promo code";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_emirates_id_field = () => {
//   // console.log("Events.clicks_on_emirates_id_field()");

//   // let event_name = "Clicks on emirates id field";
//   // let eventCategory = Events.getCategoryByArea();
//   // let eventAction = "Promo code";
//   // let eventLabel = ""
  
//   //Tracking.event(event_name, eventCategory, eventAction);
// };

// // Events.clicks_on_apply_promo_x = (promo_code) => {
// //   let event_name = "Clicks on applied promo code clear (x)";
// //   let eventCategory = Events.getCategoryByArea();
// //   let eventAction = "Promo code";

// //   Tracking.event(event_name, eventCategory, eventAction);
// // };

// Events.clicks_on_promo_code_clear = () => {
//   let event_name = "Clicks on promo code field clear (x)";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Promo code";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_cancel_promo_cancellation = (promo_code, copy) => {
//   let event_name = "Clicks on cancel in promo code cancellation popup";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Promo code";
//   let eventLabel = promo_code;
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_confirm_cancel_promo = (promo_code, copy) => {
//   let event_name = "Clicks on confirm promo code cancellation";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Promo code";
//   let eventLabel = "Promo code cancelled";
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// // Events.clicks_on_apply_promo_code = (promo_code, copy) => {
// //   let event_name = "Clicks on apply promo code";
// //   let eventCategory = Events.getCategoryByArea();
// //   let eventAction = "Promo code";
// //   let eventLabel = promo_code;

// //   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// // };

// Events.clicks_on_anghami_agree_checkbox = (val, copy) => {
//   let event_name = "Clicks on Anghami agree checkbox";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Promotions";
//   let eventLabel = copy;
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_number_shuffle = (copy) => {
//   let event_name = "Clicks on shuffle link";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Shuffle";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_book_shuffled_number = (copy) => {
//   let event_name = "Clicks on the CTA to continue with the random number";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Continue CTA";
//   let eventLabel = copy;
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_play_store_app_link = () => {
//   let event_name = "Clicks on the Play Store button";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Play Store CTA Clicked";
//   let eventLabel = Events.getPrice();
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_thank_you_store_link = () => {
//   let event_name = "Clicks on the 'find a Virgin Megastore' link";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Store Finder CTA";
//   let eventLabel = Events.getPrice();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_app_store_app_link = () => {
//   let event_name = "Clicks on the App Store button";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "App Store CTA Clicked";
//   let eventLabel = Events.getPrice();
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_go_to_search = (copy) => {
//   let event_name = "Clicks on the CTA to choose a specific number";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Specific Number CTA";
//   let eventLabel = copy;
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_go_to_mnp = (copy) => {
//   let event_name = "Clicks on the CTA to continue with the random number";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Transfer Number CTA";
//   let eventLabel = copy;
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_clear_number_search_fragment = (copy, fragment) => {
//   let event_name = "Clicks into the 'number type in' area";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Entry";
//   let eventLabel = "Number Deleted";
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_number_search_submit = (copy, fragment) => {
//   let event_name = "Clicks on the number search CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Search CTA";
//   let eventLabel = fragment;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.when_search_results_response = (results = []) => {
//   let event_name = "When search results are produced";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Search Result";
//   let eventLabel = results.length ? "Results" : "No Results";

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_number_search_field = () => {
//   let event_name = "Clicks into the 'number type in' area";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Entry";
//   let eventLabel = Events.getPlanforTracking();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_number_search_load_more = (copy) => {
//   let event_name = "Clicks on 'Show more numbers' link";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Search Result";
//   let eventLabel = "Show More Numbers";

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_account_email_field = () => {
//   let event_name = "Clicks into the 'Email' field";
//   let eventCategory = Events.getCategoryByArea;
//   let eventAction = "Email Entry";
//   let eventLabel = Events.getPlanforTracking();
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_account_password_field = () => {
//   let event_name = "Clicks into the 'Password' field";
//   let eventCategory = Events.getCategoryByArea;
//   let eventAction = "Password Entry";
//   let eventLabel = Events.getPlanforTracking();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.when_google_login_succeeds = () => {
//   let event_name = "eventTracker";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Registration";
//   let eventLabel = "Facebook Google clicked";
//   
//   Tracking.custom_event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.when_google_login_fails = () => {
//   let event_name = "eventTracker";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Registration";
//   let eventLabel = "Facebook Google clicked";
//  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_account_password_eye = () => {
//   let event_name = "Clicks on password eye toggle";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Password Entry";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_confirm_email_popup_yes = () => {
//   let event_name = "Click on CTA - YES";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Registration";
//   let eventLabel = "Your email - yes";

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_confirm_email_popup_no = () => {
//   let event_name = "Click on CTA - NO";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Registration";
//   let eventLabel = "Your email - no";
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_clear_email_field = () => {
// let event_name = "Clicks on the delete cross in the email entry field";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Email Entry";
//   let eventLabel = "Email Deleted";

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_clear_password_field = () => {
//   let event_name = "Clicks on the delete cross in the password entry field";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Password Entry";
//   let eventLabel = "Password Deleted";
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_submit_account_form = (copy) => {
//   let event_name = "Clicks on the continue CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Continue CTA";  

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.when_account_form_shows_validation_message = (copy) => {
//   let event_name = "When a field validation message appears on Account page";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Field Validation Error";
//   let eventLabel = "Email"; // <Field that errored: Email / Password>
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_resident_form_yes = (copy) => {
//   let event_name = "Clicks on the primary CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Continue CTA";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_confirm_stored_number = (copy) => {
//   let event_name = "Clicks on the primary stored number CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Stored number";
//   let eventLabel = copy;
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_cancel_stored_number = (copy) => {
//   let event_name = "Clicks on the secondary stored number CTA hyperlink";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Stored number";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_resident_form_no = (copy) => {
//   let event_name = "Clicks on the secondary CTA hyperlink";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Not Resident CTA";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.non_resident_arrived_at_payment = () => {
//   let event_name = "Non-resident arrived at payment";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Non-resident arrived at payment";
//   let eventLabel = "Non-resident";

//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction,
//     eventLabel
//   );

// };

// Events.clicks_on_non_resident_form_cta = (copy) => {
//   let event_name = "Clicks on the primary CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Continue CTA";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_non_resident_form_store_link = (copy) => {
//   let event_name = "Clicks on the secondary CTA hyperlink";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Store Finder CTA";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_delivery_map_trigger = () => {
//   let event_name = "Clicks on the map icon";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Address Map Icon";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_delivery_form_address_clear = () => {
//   let event_name = "Clicks on the Address field clear icon";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Address Field Cleared";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_delivery_form_map_address_field = () => {
//   let event_name = "Clicks into the map Address field";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Address Field Interaction";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_delivery_form_address_field = () => {
//   let event_name = "Clicks into the Address field";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Address Field Interaction";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_delivery_form_address_field_line_2 = () => {
//   let event_name = "Clicks into the 2nd field (Apartment)";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Address 2 Field Interaction";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_delivery_form_instructions_field = () => {
//   let event_name = "Clicks into the Instructions field";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Instructions Field Interaction";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_delivery_form_number_field = () => {
//   let event_name = "Clicks into the Number field";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Field Interaction";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_delivery_form_submit = (copy) => {
//   let event_name = "Clicks on the primary CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Continue CTA";
//   let eventLabel = Events.getPlanforTracking();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_delivery_form_prefer_pickup = (copy) => {
//   let event_name = "Clicks on the pickup in store hyperlink";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Collect in Store CTA";
//   let eventLabel = Events.getPlanforTracking();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_delivery_map_search_field = () => {
//   let event_name = "Clicks into the search field";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Address Map Field Interaction";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_delivery_map_set_address = (copy) => {
//   let event_name = "Clicks on the 'Deliver Here' CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Address Map Deliver Here CTA";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_delivery_form_predictions_open_map = (copy, first_result) => {
//   // i dont see my location
//   let event_name =
//     "User clicks on 'I don't see my address here' from the result dropdown list";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Address Field Results";
//   let eventLabel = first_result;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_delivery_form_autocomplete_prediction = (copy) => {
//   let event_name =
//     "User clicks on an Address result from the result dropdown list";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Address Field Results";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_mnp_form_operator = (copy) => {
//   let event_name = "Clicks on an operator option";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Operator Field Interaction";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_mnp_form_number_field = () => {
//   let event_name = "Clicks into the Number field";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Field Interaction";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_mnp_form_authorise_field = (copy, val) => {
//   let event_name = "Clicks on the radio button";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Authorised Field Interaction";
//   let eventLabel = Events.getPlanforTracking();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_mnp_form_submit = (copy) => {
//   let event_name = "Clicks on the primary CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Continue CTA";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_toggle_faq_question = (copy, expanded) => {
//   if (expanded) {
//     let event_name = "Clicks to expand an FAQ";
//     let eventCategory = Events.getCategoryByArea();
//     let eventAction = "FAQ Question Opened";
//     let eventLabel = copy;

//     Tracking.event(event_name, eventCategory, eventAction, eventLabel);
//   }
// };

// Events.clicks_on_toggle_faq_helpful = (copy, helpful) => {
//   let event_name = "Clicks on an FAQ rating";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "FAQ Question Rated";
//   let eventLabel = copy + " | " + helpful ? "Good" : "Bad";

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_mnp_terms_edit_number = () => {
//   let event_name = "When the user clicks on the red number icon";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Edit";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_mnp_terms_agree_checkbox = (copy) => {
//   let event_name = "Clicks on the first agreement radio button";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Agreed Radio Button";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_mnp_terms_cta = (copy) => {
//   let event_name = "Clicks on the primary CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Continue CTA";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// // Events.clicks_on_cc_card_form_card_field = () => {
// //   let event_name = "Clicks into the 'Card Number' field";
// //   let eventCategory = "Checkout Pay Online";
// //   let eventAction = "Card Number Field Interaction";
// //   let eventLabel = Events.getPrice();

// //   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// // };

// // Events.clicks_on_cc_card_form_cvv_field = () => {
// //   let event_name = "Clicks into the 'CVV' field";
// //   let eventCategory = "Checkout Pay Online";
// //   let eventAction = "Cardholder CVV Field Interaction";
// //   let eventLabel = Events.getPrice();

// //   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// // };

// // Events.clicks_on_cc_card_form_cardholder_field = () => {
// //   let event_name = "Clicks into the 'Cardholder name' field";
// //   let eventCategory = "Checkout Pay Online";
// //   let eventAction = "Cardholder Name Field Interaction";
// //   let eventLabel = Events.getPrice();

// //   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// // };

// // Events.clicks_on_cc_card_form_date_field = () => {
// //   let event_name = "Clicks into the 'Expiry Date' field";
// //   let eventCategory = "Checkout Pay Online";
// //   let eventAction = "Cardholder Expiry Field Interaction";
// //   let eventLabel = Events.getPrice();

// //   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// // };

// Events.clicks_on_cc_card_form_save_card_field = (copy, val) => {
//   let event_name = "Clicks into the 'Save card' field";
//   let eventCategory = "Checkout Pay Online";
//   let eventAction = "Cardholder Save Card Field Interaction";
//   let eventLabel = Events.getPrice();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_cc_card_terms_field = (copy, val) => {
//   let event_name = "Clicks on the 'terms and conditions' hyperlink";
//   let eventCategory = "Checkout Pay Online";
//   let eventAction = "Terms and Conditions";
//   let eventLabel = Events.getPrice();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_cc_card_form_submit = (copy, amount) => {
//   let event_name = "Clicks into the pay CTA";
//   let eventCategory = "Checkout Pay Online";
//   let eventAction = "Pay Online CTA";
//   let eventLabel = Events.getPrice();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// // Events.clicks_on_payment_card_option = (copy) => {
// //   let event_name = "Clicks on the 'Pay Now' CTA";
// //   let eventCategory = Events.getCategoryByArea();
// //   let eventAction = "Pay Online CTA";
// //   let eventLabel = Events.getPrice();

// //   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// // };

// // Events.clicks_on_payment_on_delivery_option = (copy) => {
// //   let event_name = "Clicks on the 'Pay on Delivery' CTA";
// //   let eventCategory = Events.getCategoryByArea();
// //   let eventAction = "Pay on Delivery CTA";
// //   let eventLabel = Events.getPrice();

// //   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// // };

// Events.clicks_on_plans_country_rates = (copy) => {
//   let event_name = "Clicks on Plans country rates link";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Plans";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_plans_page_cta = (copy, selectedProduct, products_plans) => {
//   let event_name = "Clicks on Plans Main CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Plan Change";
//   let eventLabel = copy;

//   const [, local, data, intl] = Storage.get("custom_combo").split("-");

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);

//   Tracking.metric("plan_name", `build_your_own_plan`);
//   Tracking.metric("plan_details", `${data}, ${local}, ${intl}`);
//   Tracking.metric("plan_duration", selectedProduct.CommitmentDuration);
//   Tracking.metric("plan_price", products_plans[selectedProduct.ProductCode].PackagePrice.NetPrice);

// };

// Events.clicks_on_locked_plan = (plan) => {
//   const { gtmPlanLocal, gtmPlanData, gtmPlanIntl } = Helpers.getFriendlyNumbersForGTM(plan);

//   Tracking.metric("plan_details", `${gtmPlanData}, ${gtmPlanLocal}, ${gtmPlanIntl}`);
//   Tracking.metric("plan_duration", 1);
//   Tracking.metric("plan_price", plan.PackagePrice.NetPrice);

// }

// Events.clicks_on_plan_circle_control = (direction, type) => {
//   let type_text = type;

//   if (type === "VOICE-LCL") {
//     type_text = "UAE Mins";
//   }

//   if (type === "VOICE-INT") {
//     type_text = "International";
//   }

//   if (type === "DATA") {
//     type_text = "Data";
//   }

//   let event_name = "Clicks on Plan control";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Plan Change";
//   let eventLabel = type_text + " " + direction;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_vip_product = (copy, plan) => {
//   let event_name = "Clicks on a VIP plan CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "VIP plans";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);

//   const { gtmPlanLocal, gtmPlanData, gtmPlanIntl } = Helpers.getFriendlyNumbersForGTM(plan);

//   Tracking.metric("plan_name", `vip`);
//   Tracking.metric("plan_details", `${gtmPlanData}, ${gtmPlanLocal}, ${gtmPlanIntl}`);
//   Tracking.metric("plan_duration", 12);
//   Tracking.metric("plan_price", plan.PackagePrice.NetPrice);

// };

// Events.clicks_on_payg_plan_cta = (copy) => {
//   let event_name = "Clicks on PAYG plan CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "PAYG plans";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
//   Tracking.metric("plan_name", `pay_as_you_go`);
//   Tracking.metric("plan_details", `0, 0, 0`);
//   Tracking.metric("plan_duration", 1);
//   Tracking.metric("plan_price", 0);
// };

// Events.clicks_on_plans_vat_toggle = (copy, newval) => {
//   let event_name = "Clicks on Plans VAT switch";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Plans";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_plans_tab = (which, copy) => {
//   let event_name = "Clicks on a plan tab";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Plans tabs";
//   let eventLabel = which;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_boosters_daily_limit = (copy) => {
//   let event_name = "Clicks on PAYG boosters daily limit";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "PAYG plans";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_payg_recharge_option = (val, copy) => {
//   let event_name = "Clicks on PAYG boosters recharge";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "PAYG plans";
//   let eventLabel = val;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_boosters_no_daily_limit = (copy) => {
//   let event_name = "Clicks on PAYG boosters no daily limit";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "PAYG plans";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_boosters_tab = (which, copy) => {
//   let event_name = "Clicks on PAYG boosters tab";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "PAYG plans";
//   let eventLabel = which;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.toggle_plan_perks_visibility = (copy, where, newval) => {
//   let event_name = "Clicks on expand plan perks";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Plans";
//   let eventLabel = where;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_plan_page_commitment = (product) => {
//   let event_name = "Clicks on a plan commitment";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Plans";
//   let eventLabel = product ? product.CommitmentDuration : "";

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_value_plan_cta = (copy, price) => {
//   let event_name = "Clicks on Value Plan CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Value plans";
//   let eventLabel = price;
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
//   Tracking.metric("plan_name", `starter_plans`);
// };

// Events.http_error = (code, type, value) => {
//   Tracking.metric("Error_messages_tech", 1);
//   Tracking.dimension("Error_messages_tech", code);

//   let event_name = "error";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "http";
//   let eventLabel = code;
//   let eventValue = value;

//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction,
//     eventLabel,
//     eventValue
//   );
// };

// Events.clicks_on_number_search_vanity_menu_item = (vanity) => {
//   let event_name = "Clicks on a search filter";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Filter numbers";
//   let eventLabel = vanity ? vanity.value : "";
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.toggle_number_search_vanity_menu = () => {
//   let event_name = "Clicks on search filters menu";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Filter numbers";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// Events.clicks_on_cc_card_newsletter_field = (copy, val) => {
//   let event_name = "Clicks into the 'Newsletter' field";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Newsletter Field Interaction";
//   let eventLabel = Events.getPrice();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_vip_number_confirmation = (copy, vanity) => {
//   let event_name = "Clicks on a VIP number confirmation CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "VIP plans";
//   let eventLabel = vanity;
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_vip_number_cancel = (copy, vanity) => {
//   let event_name = "Clicks on a VIP number secondary CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "VIP plans";
//   let eventLabel = vanity;
  
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_faq_feedback_submit = (feedback) => {
//   let event_name = "Clicks on an FAQ feedback CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "FAQ Question Feedback";

//   Tracking.event(event_name, eventCategory, eventAction);
// };

// // Events.clicks_on_delivery_map_find_store = (copy) => {
// //   let event_name = "Clicks on the 'Find Store' CTA";
// //   let eventCategory = Events.getCategoryByArea();
// //   let eventAction = "Address Map Find Store CTA";
// //   let eventLabel = copy;

// //   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// // };

// // Events.when_user_uses_email_form_to_register = () => {
// //   Tracking.dimension("Registration_type_flow", "Email");
// //   Tracking.metric("Email subscription (Yes-button)", 1);
// // };

// Events.when_user_logs_out = () => {
//   Tracking.dimension("customer_status", "not logged in");
//   Tracking.dimension("uid", 0);
//   Tracking.dimension("Unique_User_ID_session", "");
//   Tracking.dimension("Unique_User_ID_user", "");
//   Tracking.dimension("registration_type", "");
//   Tracking.dimension("Promotion_type", "");
//   Tracking.dimension("Plan selected (Customer)", "");
//   Tracking.dimension("Number selected (Customer)", "");
//   Tracking.dimension("Promotion_type", "");
//   Tracking.dimension("Promotion_type", "");
// };

// Events.when_user_session_is_found = () => {
//   Tracking.dimension("customer_status", "logged in");
// };

// Events.when_user_registers_using_type = (type) => {
//   Tracking.dimension("Registration_type_flow", type);
//   Tracking.dimension("Registration_type_customer", type);
// };

// Events.when_user_registration_type_is_found = (type) => {
//   Tracking.dimension("registration_type", type);
// };

// Events.when_user_id_is_found = (uid) => {
//   Tracking.dimension("uid", uid);
// };

// Events.when_user_account_id_is_set = (account_id) => {
//   Tracking.dimension("account_id", account_id);
// };

// Events.when_plan_is_selected = () => {
//   let plan = Storage.get("saved_plan");

//   let product = Storage.get("selectedProduct");

//   let coupon = "";

//   let promotion = null;
//   if (plan && plan.Promotions) {
//     for (let promo of plan.Promotions) {
//       if (promo && promo["IsUserPromo"]) {
//         promotion = promo;
//         break;
//       }
//     }
//   }

//   let sub_plan_values = Events.getPlanforTracking();

//   if (promotion) {
//     coupon = promotion.Category;
//   }

//   let type = Events.getPlanTypeforTracking();

//   Tracking.impression({
//     price: Events.getPrice(),
//     name: product["Name"],
//     id: sub_plan_values,
//     category: "SIM",
//     variant: type,
//     coupon: coupon ? coupon : "",
//   });

//   let formatted = "";

//   if (type === "PAYG") {

//     let recharge_amount = 0;

//     let extraCharges = plan.PackagePrice.ExtraCharges;
//     for (let charge of extraCharges) {
//       if (charge["Name"] === "RechargeAmount") {
//         recharge_amount = charge["Amount"];
//         break;
//       }
//     }

//     formatted = type + " " + recharge_amount
//   } else {
//     formatted = type + " " + product["CommitmentDuration"] + "|" + sub_plan_values;
//   }

//   Tracking.dimension("Plan selected (Selected)", formatted);
// };

// Events.when_number_is_selected = (numberobj) => {
//   Tracking.dimension(
//     "Number selected (Selected)",
//     Events.getNumberTypeforTracking(numberobj)
//   );
// };

// Events.clicks_on_number_search_result = (number, index_in_list) => {
//   let event_name = "Clicks on a number search result";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Search Result";
//   let eventLabel = index_in_list;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_vip_number_search_result = (number, index_in_list) => {
//   let event_name = "Clicks on a vip number search result";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Number Search Result";
//   let eventLabel = index_in_list;
//   let eventValue = Helpers.isVipNumber(number.VanityLevel);

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel, eventValue);
// };

// Events.clicks_on_plans_int_mins_continue = (copy) => {
//   let event_name = "Clicks on a international minutes continue CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Continue CTA";
//   let eventLabel = copy;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.clicks_on_plan_circle_info_icon = (type) => {
//   let event_name = "Clicks on Plan circle info icon";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Plans";
//   let eventLabel = type;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.when_user_cancels_CC_form = (copy) => {
//   let event_name = "Clicks on the pay now cancel button";
//   let eventCategory = "Checkout Pay Online";
//   let eventAction = "Pay Online";
//   let eventLabel = Events.getPrice();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.when_user_cancels_POD = (copy) => {
//   let event_name = "Clicks on the pay on delivery cancel button";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Pay on delivery";
//   let eventLabel = Events.getPrice();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.when_user_submits_POD = (copy) => {
//   let event_name = "Clicks on the pay on delivery confirm CTA";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Pay on delivery CTA";
//   let eventLabel = Events.getPrice();

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.when_POD_fails = (type, code) => {
//   let title = "";
//   if (Globals["messages"][type]) {
//     title = Globals["messages"][type]["title"];
//   }

//   let coder = code !== true ? code : "";

//   Tracking.metric("Error_messages_tech", 1);
//   Tracking.dimension("Error_messages_tech", coder);

//   Tracking.event(
//     "POD_failed",
//     "Payment",
//     "POD failed",
//     title ? title + (coder ? "/" + coder : "") : coder
//   );
// };

// Events.when_payment_fails = (type, code, where = "") => {
//   let title = "";
//   if (Globals["messages"][type]) {
//     title = Globals["messages"][type]["title"];
//   }

//   let coder = code !== true ? code : "";

//   Tracking.metric("Error_messages_tech", 1);
//   Tracking.dimension("Error_messages_tech", coder);

//   Tracking.event(
//     "Payment_failed",
//     "Checkout Pay Online",
//     `"Payment failed-"
//       ${title ?
//         title + (coder ? "/" + coder : "") + " " + where :
//         coder + " " + where
//       }`,
//       Storage.get('selectedPaymentMethod')
//   );
// };

// // @TODO

// let when_pod_or_card_succeeds = () => {
//   let product = Storage.get("selectedProduct");
//   let commit = product ? product.CommitmentDuration : "";

//   let sub_plan_value = Events.getPlanforTracking();

//   let type = Events.getPlanTypeforTracking();

//   let transactionId = Storage.get("order_id");

//   let transactionTotal = Events.getPrice();

//   let SKU = "";

//   if (type === "PAYG") {
//     let recharge_amount = 0;
//     let plan = Storage.get("saved_plan");
//     let extraCharges = plan.PackagePrice.ExtraCharges;
//     for (let charge of extraCharges) {
//       if (charge["Name"] === "RechargeAmount") {
//         recharge_amount = charge["Amount"];
//         break;
//       }
//     }
//     SKU = type + " " + recharge_amount;

//   } else {
//     SKU = type + " " + commit + "|" + sub_plan_value;
//   }

//   let name = SKU;

//   Tracking.ecommerce(transactionId, transactionTotal, SKU, name);
// };

// Events.when_POD_succeeds = () => {
//   Tracking.metric("Payment on delivery", 1);
//   when_pod_or_card_succeeds();
// };

// Events.when_payment_succeeds = () => {
//   Tracking.event(
//     "Payment_successful",
//     "Checkout Pay Online",
//     "Payment successful",
//     "Success"
//   );

//   Tracking.metric("Credit card payment", 1);
//   when_pod_or_card_succeeds();
// };

// Events.resident_paid_online_arrived_at_thank_you = () => {
//   let event_name = "Resident (online-flow) arrived at payment";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Resident (online-flow) arrived at payment";
//   let eventLabel = "Resident (online-flow)";

//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction,
//     eventLabel
//   );

// };

// Events.non_resident_paid_online_arrived_at_thank_you = () => {
//   let event_name = "Non-resident (online-flow) arrived at thank you";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Non-resident (online-flow) arrived at thank you";
//   let eventLabel = "Non-resident (online-flow)";

//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction,
//     eventLabel
//   );
// };

// Events.non_resident_collect_store_arrived_at_thank_you = () => {
//   let event_name = "Non-resident (collect in store) arrived at thank you";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Non-resident (collect in store) arrived at thank you";
//   let eventLabel = "Non-resident (collect in store)";

//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction,
//     eventLabel
//   );
// };

// Events.resident_collect_store_arrived_at_thank_you = () => {
//   let event_name = "Resident (collect in store) arrived at thank you";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Resident (collect in store) arrived at thank you";
//   let eventLabel = "Resident (collect in store)";

//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction,
//     eventLabel
//   );
// };



// Events.non_resident_arrived_at_thank_you = () => {
//   let event_name = "Non-resident arrived at thank you";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Non-resident arrived at thank you";
//   let eventLabel = "Non-resident";

//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction,
//     eventLabel
//   );
// };

// Events.redirectd_to_thank_you = (callback) => {

//   let event_name = "Redirects to thank you page";
//   let eventCategory = "Checkout Payment";
//   let eventAction = "Redirect To Thank You Page";
//   let eventLabel = "Payment completed";
//   if (typeof callback === 'function') {
//     Tracking.event_with_callback(
//       event_name,
//       eventCategory,
//       eventAction,
//       eventLabel,
//       callback()
//     );
//   } else {
//     Tracking.event(
//       event_name,
//       eventCategory,
//       eventAction,
//       eventLabel
//     );
//   }
// };

// Events.reached_to_thank_you_page = () => {
//   let event_name = "Reached thank you page";
//   let eventCategory = "Checkout Confirmation";
//   let eventAction = "Confirmation. Reached"
//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction
//   );
// }

// //pixels events
// // Events.clicks_on_pixel_plan_selected = () => {
// //   let event_name = "pixel_plan_selected";
// //   let plan_selection_1 = Storage.get("pixel_plan_selection_l1");
// //   let plan_selection_2 = Storage.get("pixel_plan_selection_l2");
// //   let eventValue = Storage.get("pixel_plan_price");
// //   Tracking.pixel_event(event_name, plan_selection_1, plan_selection_2, eventValue);
// // }

// // Events.clicks_on_pixel_account_created = () => {
// //   let event_name = "pixel_account_created";
// //   let plan_selection_1 = Storage.get("pixel_plan_selection_l1");
// //   let plan_selection_2 = Storage.get("pixel_plan_selection_l2");
// //   let eventValue = Storage.get("pixel_plan_price") ? Storage.get("pixel_plan_price") : Events.getPrice();
// //   Tracking.pixel_event(event_name, plan_selection_1, plan_selection_2, eventValue);
// // }

// // Events.pixel_payment_page_viewed = () => {
// //   let event_name = "pixel_payment_viewed";
// //   let plan_selection_1 = Storage.get("pixel_plan_selection_l1");
// //   let plan_selection_2 = Storage.get("pixel_plan_selection_l2");
// //   let eventValue = Storage.get("pixel_plan_price") ? Storage.get("pixel_plan_price") : Events.getPrice();
// //   Tracking.pixel_event(event_name, plan_selection_1, plan_selection_2, eventValue);
// // }

// // Events.pixel_purchase = () => {
// //   let event_name = "pixel_purchase";
// //   let plan_selection_1 = Storage.get("pixel_plan_selection_l1");
// //   let plan_selection_2 = Storage.get("pixel_plan_selection_l2");

// //   let eventValue = Storage.get("pixel_plan_price") ? Storage.get("pixel_plan_price") : Events.getPrice();
// //   let transaction_id = Storage.get("order_id") ? Storage.get("order_id") : (Storage.get("selected_store_pickup") ? "PIN" : "N/A");

// //   Tracking.pixel_purchase_event(event_name, plan_selection_1, plan_selection_2, eventValue, transaction_id);
// // }

// Events.pushConvertRevenue = () => {
//   window._conv_q = window._conv_q || [];
//   let revenue = Events.getPrice();
//   window._conv_q.push(["pushRevenue", revenue, 1, "100316389"]);
//   window._conv_q.push(["pushRevenue", revenue, 1, "100316796"]);
//   window._conv_q.push(["triggerConversion", "100316390"]);
//   window._conv_q.push(["triggerConversion", "100316797"]);
// }

// //Money Back Guarentee Modal events
// Events.money_back_guarentee_conditions_apply_clicked = (hyperlink_label) => {
//   let event_name = hyperlink_label;
//   let eventCategory = "Refund";
//   let eventAction = "Hyperlink clicked";
//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction
//   );
// }

// Events.money_back_guarentee_refund_faq_clicked = (hyperlink_label) => {
//   let event_name = hyperlink_label;
//   let eventCategory = "Refund";
//   let eventAction = "Overlay hyperlink";
//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction
//   );
// }

// Events.money_back_guarentee_modal_overlay_closed = (close_modal_label) => {
//   let event_name = close_modal_label;
//   let eventCategory = "Refund";
//   let eventAction = "Overlay closed";
//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction
//   );
// }

// //Above 18 modal events
// Events.under_18_please_read_link_clicked = (hyperlink_label) => {
//   let event_name = hyperlink_label;
//   let eventCategory = "Account Creation";
//   let eventAction = "Under 18 clicked";
//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction
//   );
// }

// Events.under_18_modal_family_Plan_link_clicked = () => {
//   let eventCategory = "Account Creation";
//   let eventAction = "Family Plan link clicked";
//   Tracking.event(
//     eventCategory,
//     eventAction
//   );
// }

// Events.under_18_modal_overlay_CTA_clicked = (close_modal_label) => {
//   let event_name = close_modal_label;
//   let eventCategory = "Account Creation";
//   let eventAction = "Overlay CTA clicked";
//   Tracking.event(
//     event_name,
//     eventCategory,
//     eventAction
//   );
// }

// Events.user_interacts_with_accessibility_options = (which_button) => {
//   Tracking.event(
//     "User interacts with accessibility options",
//     "Accessibility",
//     "Header accessibility option clicked",
//     which_button
//   );
// };

// Events.clicked_on_promos_ab_card = (promo_title) => {

//   let event_name = "Promotion clicked";
//   let eventCategory = "Plan page promotion box";
//   let eventAction = "Promotion clicked";
//   let eventLabel = promo_title;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// };

// Events.registration_apps_link_clicked = () => {}

// Events.when_promocode_auto_applied= (promocode) => {
//   let event_name = "Auto-apply promocode";
//   let eventCategory = "Auto-promocode";
//   let eventAction = "Applied";
//   let eventLabel = promocode;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// }

// Events.user_reaches_checkout_with_plan = (plan_details) => {
//   let event_name = "Checkout with plan";
//   let eventCategory = "Checkout Plan";
//   let eventAction = "Plan chosen";
//   let eventLabel = plan_details;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// }

// Events.user_passes_plan_selection = (plan_details) => {
//   let event_name = "User passes plan selection";
//   let eventCategory = "Plan";
//   let eventAction = "Plan chosen";
//   let eventLabel = plan_details;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// }

// Events.user_chooses_address_type = (address_type) => {
//   let event_name = "When the user chooses an address type";
//   let eventCategory = "Contract request";
//   let eventAction = "Address type chosen";
//   let eventLabel = address_type;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// }

// Events.contract_delivery_form_successful = (location) => {
//   let event_name = "When the form is successful";
//   let eventCategory = "Contract request";
//   let eventAction = "Form successful";
//   let eventLabel = location;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// }
// Events.when_payment_is_successful = (option) => {
//   let event_name = "Successful payment";
//   let eventCategory = "Payment";
//   let eventAction = "Payment success";
//   let eventLabel = option;
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// }

// Events.clicks_on_continue_payment_type_overlay = (option) => {
//   let event_name = "User clicked on CTA button of the payment options after selecting option for payment";
//   let eventCategory = "Payment";
//   let eventAction = "Payment type selected";
//   let eventLabel = option;

//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// }

// Events.clicks_on_cancel_payment_type_overlay = () => {
//   let event_name = "User clicked on ‘cancel’ CTA to close the payment type overlay";
//   let eventCategory = "Payment";
//   let eventAction = "Payment type cancel";

//   Tracking.event(event_name, eventCategory, eventAction, '');
// }

// Events.when_account_is_created = () => {
//   let event_name = "Form is successfully sent by the user";
//   let eventCategory = "Form success";
//   let eventAction = "Form successfully submitted";
//   let eventLabel = "Mobile SIM";
//   Tracking.event(event_name, eventCategory, eventAction, eventLabel);
// }

//GA4 events
// Events.clicks_on_plan_circle_control = (direction, type) => {
//   // console.log("Events.clicks_on_plan_circle_control()", direction, type);

//   let type_text = type;

//   if (type === "VOICE-LCL") {
//     type_text = "UAE Mins";
//   }

//   if (type === "VOICE-INT") {
//     type_text = "International";
//   }

//   if (type === "DATA") {
//     type_text = "Data";
//   }

//   let event_name = "Clicks on Plan control";
//   let eventCategory = Events.getCategoryByArea();
//   let eventAction = "Plan Change";
//   let eventLabel = type_text + " " + direction;
//   

//   Tracking.GA4Ecommerce(event_name, eventCategory, eventAction, eventLabel);
// };



const CUSTOM_ITEM_INDEX = {
    "1" : 1,
    "6" : 2,
    "12": 3 
  }

//New Events

//Ecommerce events
Events.when_user_clicks_on_plan_circle_control = (plan) => {
  //preparing ecommerce obj to use in the next eCommerce events
  let coupon =  '';
  let plan_sub_category = "cus";
  let plan_price = Events.getPrice(plan);
  let plan_name = plan.name;
  let custom_event_name = "view_item_list";
  let discount = 0;
  let custom_combo = Storage.get("custom_combo", true);
  const [plan_duration, voice, data, intl_min] = custom_combo.split("-");
  let month_text = plan_duration > 1 ? ' months' : ' month';
  let sub_journey_name = `${"build your own plan " + plan_duration}` 

  Tracking.GA4Ecommerce(
    data,
    voice,
    intl_min,
    plan_name,
    plan_price,
    coupon,
    `cus ${plan_duration}|${data}|${voice}|${intl_min}`,
    `${plan_duration + month_text}`,
    sub_journey_name,
    plan_sub_category,
    custom_event_name,
    discount
  );
};

Events.when_user_loads_custom_plans = (products, plans) => {
  let plan_sub_category = "cus";
  let items_list = [];
  const [duration, voice, data, intl_min] = Storage.get("custom_combo", true).split("-");
  let sub_journey_name = `build your own plan ${duration}`;
  let i = 1;
  products.forEach((product)=>{
    let plan =  plans[product.ProductCode];
    let price = Events.getPrice(plan);
    let plan_duration = product.CommitmentDuration;
    let item_id = `cus ${plan_duration}|${data}|${voice}|${intl_min}`;
    items_list.push({
      item_id,
      item_name: item_id,
      item_brand: "virgin mobile uae",
      index: i,
      coupon: '',
      discount: 0,
      item_category: "mobile plan",
      item_category2: plan_sub_category,
      item_category3: `data: ${data} gb|local: ${voice} min|intl: ${intl_min} min`,
      item_category4: `${plan_duration} ${plan_duration===1?'month':'months'}` ,
      item_list_name: "",
      item_list_id: "",
      price,
      quantity: 1
    });
    i = i + 1;
  })
  Tracking.GA4EcommerceWithList("view_item_list", sub_journey_name, items_list);
  Tracking.GA4EcommerceWithList("view_item", sub_journey_name, items_list);
}

// Events.when_user_clicks_plan_commitment_control = (product, plan) => {
//   //preparing ecommerce obj to use in the next eCommerce events
//   let coupon =  '';
//   let plan_sub_category = "cus";
//   let plan_price = Events.getPrice(plan);
//   let plan_name = product.name;
//   let custom_event_name = "view_item_list";
//   let discount = 0;
//   let plan_duration = product.CommitmentDuration;
//   const [ , voice, data, intl_min] = Storage.get("custom_combo", true).split("-");
//   let month_text = plan_duration > 1 ? ' months' : ' month';
//   let sub_journey_name = `${"build your own plan " + plan_duration}` 

//   Tracking.GA4Ecommerce(
//     data,
//     voice,
//     intl_min,
//     plan_name,
//     plan_price,
//     coupon,
//     `cus ${plan_duration}|${data}|${voice}|${intl_min}`,
//     `${plan_duration + month_text}`,
//     sub_journey_name,
//     plan_sub_category,
//     custom_event_name,
//     discount
//   );
// };

Events.when_user_views_item = () => {
  let obj = {
    custom_event_name : "view_item",
  }
  Tracking.GA4EcommerceWithExtraParams(obj);
};

Events.when_user_loads_vip_plans = (plans) => {
  //preparing ecommerce obj to use in the next eCommerce events
  let plan_duration = 12;
  let plans_list = [];
  let planArr = plans? Object.keys(plans) : [];
  planArr.forEach((key,i) => {
    const { gtmPlanLocal, gtmPlanData, gtmPlanIntl } = Helpers.getFriendlyNumbersForGTM(plans[key]);
    let price = plans[key].PackagePrice["NetPrice"];
    let item_id = `vip ${plan_duration}|${gtmPlanData}|${gtmPlanLocal}|${gtmPlanIntl}`;
    let category2 = Numbers.isBundleProductByID(plans[key]['vanity_id'])? "vip bundle plans":"vip plans";
    plans_list.push({
      item_id,
      item_name: item_id,
      item_brand: "virgin mobile uae",
      index: i+1,
      coupon: '',
      discount: Number(plans[key].PackagePrice?.PromotionDiscountAmount),
      item_category: "mobile plan",
      item_category2: category2,
      item_category3: `data: ${gtmPlanData} gb|local: ${gtmPlanLocal} min|intl: ${gtmPlanIntl} min`, //plan details (data, local, intl)
      item_category4: `${plan_duration} months` ,
      item_list_name: "",
			item_list_id: "",
      price: price,
      quantity: 1
    })
  });
  Tracking.GA4EcommerceWithList("view_item_list", "vip plans", plans_list);
  Tracking.GA4EcommerceWithList("view_item", "vip plans", plans_list);
 
}
Events.when_user_loads_payg_plans = (plan, rechargeAmount, activeText) => {
  let coupon =  '';
  let discount = 0;
  let plan_duration = 1;
  let plan_sub_category = "payg";
  let plan_name = plan.plan_name;
  let custom_event_name = "view_item_list";
  let plan_price = Events.getPrice(plan);
  let custom_combo = `payg ${rechargeAmount}`;
  let sub_journey_name = `payg ${activeText} ${rechargeAmount}`;
  const { gtmPlanLocal, gtmPlanData, gtmPlanIntl } = Helpers.getFriendlyNumbersForGTM(plan);
  Tracking.GA4Ecommerce(
    gtmPlanData,
    gtmPlanLocal,
    gtmPlanIntl,
    plan_name,
    plan_price,
    coupon,
    custom_combo,
    `${plan_duration} month`,
    sub_journey_name,
    plan_sub_category,
    custom_event_name,
    discount
  );
};

Events.when_user_loads_starter_plans = (plans) => {
  let custom_event_name = "view_item_list";
  let sub_journey_name = "starter plans";
  let plans_list = [];
  for (let i = 0; i < plans.length; i++) {
    const planDuration = 1;
    const { gtmPlanLocal, gtmPlanData, gtmPlanIntl } = Helpers.getFriendlyNumbersForGTM(plans[i]);
    let monthly = plans[i]["PackagePrice"]["MonthlyPrice"];
    let vat_percentage = plans[i]["PackagePrice"]["VATPercentage"];
    let vat_excl_factor = 100 / (100 + parseFloat(vat_percentage, 10) * 100);
    let monthly_no_vat = monthly * vat_excl_factor;
    let item_id = `starter ${monthly_no_vat}`
    plans_list.push({
      item_id,
      item_name: item_id,
      item_brand: "virgin mobile uae",
      index: i + 1,
      coupon: '',
      discount: Number(plans[i].PackagePrice?.PromotionDiscountAmount),
      item_category: "mobile plan",
      item_category2: "starter",
      item_category3: `data: ${gtmPlanData} gb|local: ${gtmPlanLocal} min|intl: ${gtmPlanIntl} min`, //plan details (data, local, intl)
      item_category4: `${planDuration} month`,
      item_list_name: "",
			item_list_id: "",
      price: Events.getPrice(plans[i]),
      quantity: 1
    })
  }
  Tracking.GA4EcommerceWithList(custom_event_name, sub_journey_name, plans_list);
};

Events.when_user_clicks_on_cus_plans_cta = (selectedProduct, selectedCustomPlan) => {
  //preparing ecommerce obj to use in the next eCommerce events
  let coupon =  '';
  let plan_sub_category = "cus";
  let plan_price = Events.getPrice(selectedCustomPlan);
  let plan_name = selectedProduct.name;
  let custom_event_name = "select_item";
  let plan_duration = selectedProduct.CommitmentDuration;
  let item_index = CUSTOM_ITEM_INDEX[plan_duration];
  let discount = Number(selectedCustomPlan?.PackagePrice?.PromotionDiscountAmount);
  let month_text = plan_duration > 1 ? ' months' : ' month';
  let custom_combo = "cus " + Storage.get("custom_combo", true);
  const [, voice, data, intl_min] = custom_combo.split("-");
  let sub_journey_name = `${"build your own plan " + plan_duration}` 

  Tracking.GA4Ecommerce(
    data,
    voice,
    intl_min,
    plan_name,
    plan_price,
    coupon,
    `cus ${plan_duration}|${data}|${voice}|${intl_min}`,
    `${plan_duration + month_text}`,
    sub_journey_name,
    plan_sub_category,
    custom_event_name,
    discount,
    item_index
  );
};

Events.when_user_clicks_on_vip_plans_cta = (plan, index) => {
  let isBundle = Numbers.isBundleProductByID(plan?.vanity_id);
  let bundle = isBundle?' bundle':''
  //preparing ecommerce obj to use in the next eCommerce events
  let coupon =  '';
  let discount = 0;
  let plan_duration = 12;
  let plan_sub_category = `vip${bundle}`;
  let custom_event_name = "select_item";
  let plan_price = Events.getPrice(plan);
  let plan_name = plan.product_name;
  let sub_journey_name = `vip${bundle} - ${plan.product_name}`
  const { gtmPlanLocal, gtmPlanData, gtmPlanIntl } = Helpers.getFriendlyNumbersForGTM(plan);
  let custom_combo = `vip ${plan_duration}|${gtmPlanData}|${gtmPlanLocal}|${gtmPlanIntl}`;
  Tracking.GA4Ecommerce(
    gtmPlanData,
    gtmPlanLocal,
    gtmPlanIntl,
    plan_name,
    plan_price,
    coupon,
    custom_combo,
    `${plan_duration} months`,
    sub_journey_name,
    plan_sub_category,
    custom_event_name,
    discount,
    Number(index)
  );
};

Events.when_user_clicks_on_payg_plan_cta = (plan, rechargeAmount, activeText) => {
  let businessConfig = Storage.get("businessConfig");
  let recharchList = businessConfig?.list_of_recharges_payg;
  let index = 0;
  if (recharchList) {
    // find plan index as displayed in the UI: 
    index = recharchList.findIndex((p)=> p===rechargeAmount)
  }
  //preparing ecommerce obj to use in the next eCommerce events
  let coupon =  '';
  let discount = 0;
  let plan_duration = 1;
  let plan_sub_category = "payg";
  let plan_name = plan.plan_name;
  let custom_event_name = "select_item";
  let plan_price = Events.getPrice(plan);
  let custom_combo = `payg ${rechargeAmount}`;
  let sub_journey_name = `payg ${activeText} ${rechargeAmount}`;
  const { gtmPlanLocal, gtmPlanData, gtmPlanIntl } = Helpers.getFriendlyNumbersForGTM(plan);
  Tracking.GA4Ecommerce(
    gtmPlanData,
    gtmPlanLocal,
    gtmPlanIntl,
    plan_name,
    plan_price,
    coupon,
    custom_combo,
    `${plan_duration} month`,
    sub_journey_name,
    plan_sub_category,
    custom_event_name,
    discount,
    index+1
  );
};

Events.when_user_clicks_on_starter_plan_cta = (plan, amount, index) => {
  //preparing ecommerce obj to use in the next eCommerce events
  let coupon =  '';
  let discount = 0;
  let plan_duration = 1;
  let plan_sub_category = "starter";
  let plan_name = plan.plan_name;
  let custom_event_name = "select_item";
  let plan_price = Events.getPrice(plan);
  let custom_combo = `starter ${amount}`;
  let sub_journey_name = `starter ${amount}`;
  const { gtmPlanLocal, gtmPlanData, gtmPlanIntl } = Helpers.getFriendlyNumbersForGTM(plan);
  Tracking.GA4Ecommerce(
    gtmPlanData,
    gtmPlanLocal,
    gtmPlanIntl,
    plan_name,
    plan_price,
    coupon,
    custom_combo,
    `${plan_duration} month`,
    sub_journey_name,
    plan_sub_category,
    custom_event_name,
    discount,
    index
  );
};

Events.when_user_clicks_on_cta_add_to_cart = () => {
  let obj = {
    custom_event_name : "add_to_cart",
  }
  Tracking.GA4EcommerceWithExtraParams(obj);
};

Events.when_user_add_iphone_to_cart = (deviceObj, index) => {
  if (!deviceObj) return;
  let ecommerceObj = JSON.parse(Storage.get("eCommerceObj", true));
  if (ecommerceObj?.ecommerce?.items){
    let vipPlanItem = Storage.get("vip_bundle_plan_for_tracking",true);
    ecommerceObj.ecommerce.items = [
      vipPlanItem? JSON.parse(vipPlanItem): [],
      {
      item_id: deviceObj.ID,
      item_name: deviceObj.Name,
      item_brand: 'apple',
      index,
      discount:0,
      coupon: "",
      item_category: "devices",
      item_category2: "",
      item_category3: deviceObj.ExtraDetails?.Colour,
      item_category4: deviceObj.ExtraDetails?.Storage,
      item_variant: deviceObj.ExtraDetails?.Name,
      item_list_id: "",
      item_list_name: "",
      price:deviceObj.Price,
      quantity: 1 
    }]
  }
  Storage.set("eCommerceObj", JSON.stringify(ecommerceObj), true);
  let obj = {
    custom_event_name : "select_item",
  }
  Tracking.GA4EcommerceWithExtraParams(obj);
  obj.custom_event_name = 'add_to_cart';
  Tracking.GA4EcommerceWithExtraParams(obj);

};



Events.when_user_clicks_on_cta_remove_from_cart = () => {
  let obj = {
    custom_event_name : "remove_from_cart",
  }
  Tracking.GA4EcommerceWithExtraParams(obj);
};

Events.when_user_views_checkout_page = () => {
  let obj = {
    custom_event_name : "view_cart",
    customer_type : Storage.get("is_resident", true),
  }
  Tracking.GA4EcommerceWithExtraParams(obj);
};

Events.when_user_begins_checkout_flow = ()=> {
  let obj = {
    custom_event_name : "begin_checkout",
    customer_type : Storage.get("is_resident", true),
  }
  Tracking.GA4EcommerceWithExtraParams(obj);
};

Events.when_user_starts_adding_shipping_info = ()=> {
  let obj = {
    custom_event_name : "add_shipping_info",
    customer_type : Storage.get("is_resident", true),
  }
  Tracking.GA4EcommerceWithExtraParams(obj);
};

Events.when_user_starts_adding_payment_info = (type) => {
  let obj = {
    custom_event_name : "add_payment_info",
    ecommerce: {
      ...JSON.parse(Storage.get("eCommerceObj", true)).ecommerce,
      payment_type: type,
    }
  }
  Tracking.GA4EcommerceWithExtraParams(obj);
};

const findOrderIDforGTM = () => {
	let orderID = Storage.get("order_id");
	if (orderID) return orderID;

	let uid = Storage.get("account_id", true);
	let timestamp = Date.now();
  let prefix = Storage.get("paid_online", true) === true ? '' : "pod-"
	return Storage.get("selected_store_pickup", true)? `pis-${timestamp}-${uid}` : `${prefix}${timestamp}-${uid}`
}

Events.when_user_finished_purchase_flow = () => {
  let vat = Storage.get('saved_plan')?.PackagePrice?.VATAmount;
  let coupon = Storage.get("appliedPromoCode") || '';
  let ecommerceObj = JSON.parse(Storage.get("eCommerceObj", true)).ecommerce;
  if(ecommerceObj.items && 'coupon' in  ecommerceObj.items[0]) {
    ecommerceObj.items[0]['coupon'] = coupon;
  }
  let shipping_tier =  (!Storage.get("paid_online", true) && Storage.get("selected_store_pickup", true))? 'pick up from store':'delivery';
  let obj = {
    custom_event_name : "purchase",
    ecommerce: {
      ...ecommerceObj,
      transaction_id: findOrderIDforGTM(),
      value: Events.getPrice(), //final transaction amount
      tax: vat, //taxes on transaction
      shipping: 0, //shipping or delivery charges
      currency: "aed",
      shipping_tier,
      coupon
    }
  }
  Tracking.GA4EcommerceWithExtraParams(obj);
};

Events.when_user_views_all_iphone_options = (list, category) => {
  let ecommerceObj = JSON.parse(Storage.get("eCommerceObj",true));
  Storage.set("vip_bundle_plan_for_tracking",JSON.stringify(ecommerceObj?.ecommerce?.items?.[0]),true);
  let item_keys = Object.keys(list);
  let item_list = [];
  item_keys.forEach((item,i)=>{
    let price = list[item].find(d=>d.Price).Price;
      item_list.push({
        item_id: item,
        item_name: item,
        item_brand: "apple",
        index: i+1,
        coupon: '',
        discount: 0,
        item_category: "devices",
        item_category2: "",
        item_category3: "",
        item_category4: "",
        item_variant: 'iphone',
        item_list_name: "",
        item_list_id: "",
        price,
        quantity: 1
      })
    });
    Tracking.GA4EcommerceWithList("view_item_list", `vip bundle - ${category}`, item_list);
}

Events.when_user_views_default_selection = (deviceArr, category) => {
  if (!deviceArr) return;
    let price = deviceArr.find(d=>d.Price).Price;
    let selected = deviceArr.findIndex(d=>d.ExtraDetails?.Status==="1");

    let viewed_item = [{
      item_id:deviceArr[selected]['Name'],
      item_name: deviceArr[selected]['Name'],
      item_brand: "apple",
      index: selected+1,
      coupon: '',
      discount: 0,
      item_category: "devices",
      item_category2: "",
      item_category3: deviceArr[selected]?.ExtraDetails.Colour,
      item_category4: "",
      item_variant: 'iphone',
      item_list_name: "",
      item_list_id: "",
      price,
      quantity: 1
    }]
    Tracking.GA4EcommerceWithList("view_item", `vip bundle - ${category}`, viewed_item);
}
Events.when_user_views_iphone_selection = (clrArr, category, deviceArr) => {
  let index = 0;
  let name = clrArr?.Name
  if (deviceArr && deviceArr.variations) {
    let colorsList = Object.keys(deviceArr.variations).map(item=>deviceArr.variations[item].Name);
    if (colorsList){
      index = colorsList.findIndex(c=>c===name)
    }
  }
    let price = clrArr?.Price;

    let viewed_item = [{
      item_id:clrArr?.Name,
      item_name: clrArr?.Name,
      item_brand: "apple",
      index: index+1,
      coupon: '',
      discount: 0,
      item_category: "devices",
      item_category2: "",
      item_category3: clrArr?.ExtraDetails?.Colour,
      item_category4: clrArr?.ExtraDetails?.Storage,
      item_variant: 'iphone',
      item_list_name: "",
      item_list_id: "",
      price,
      quantity: 1
    }]
    Tracking.GA4EcommerceWithList("view_item", `vip bundle - ${category}`, viewed_item);
}

//Custom events
Events.when_user_clicks_on_footer_links = (title) => {
  let event_name = "eventTracker";
  let event_custom_name = "navigation_footer";
  let extra_obj = {
    nav_cta_name: title
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_plans_int_mins_continue = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "button",
    cta_position : "body"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_click_on_tabs_cta = (label, position) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "tab",
    cta_position : position
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_expand_faq_question = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "button",
    cta_position : "bottom"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_collapse_faq_question = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "button",
    cta_position : "bottom"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_toggle_faq_helpful = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "button",
    cta_position : "body"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_toggle_faq_not_helpful = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "button",
    cta_position : "body"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_faq_feedback_submit = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: "faq" + label,
    cta_type: "button",
    cta_position : "bottom"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_plan_upsell_ctas = (title) => {
  let event_name = "eventTracker";
  let event_custom_name = "plan_upsell";
  let extra_obj = {
    cta_name: title,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_plan_upsell_update_cta = (duration) => {
  let event_name = "eventTracker";
  let event_custom_name = "plan_upsell";
  let extra_obj = {
    cta_action: `from_duration ${duration} month`,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_error_pop_up_cta = (name, type, code, message) => {
  let event_name = "eventTracker";
  let event_custom_name = "error_occurred";
  let extra_obj = {
    error_name: name,
    error_type: type,
    error_code : code,
    error_message: message
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_payg_recharge_option = (amount) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: `recharge amount ${amount}`,
    cta_type: "button",
    cta_position : "bottom"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_boosters_daily_limit_ctas = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "tab",
    cta_position : "bottom"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_click_on_vat_toggle = () => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: "vat toggle",
    cta_type: "toggle",
    cta_position : "bottom"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_vip_more_info = (title) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: title,
    cta_type: "button",
    cta_position : "bottom"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicked_on_delivery_location = (location_title) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: location_title,
    cta_type: "button",
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_resident_form_buttons = (title, type) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: title,
    cta_type: type,
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_mnp_form_operator = (operator) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: operator,
    cta_type: "button",
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_delivery_form_fields = (action) => {
  let event_name = "eventTracker";
  let event_custom_name = "checkout_shipping_interaction";
  let extra_obj = {
    delivery_action_type : action,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_contarct_delivery_form_fields = (action) => {
  let event_name = "eventTracker";
  let event_custom_name = "contarct_checkout_shipping_interaction";
  let extra_obj = {
    delivery_action_type : action,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_temporary_number_tooltip_icon= () => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name : 'mnp_tooltip'
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_payment_option = (payment_title) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: payment_title,
    cta_type: "radio button",
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_mnp_form_authorise_field = (copy) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: copy,
    cta_type: "radio_button",
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_mnp_form_submit = (copy) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: copy,
    cta_type: "button",
    cta_position : "bottom"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_interacts_with_accessibility_options = (button) => {
  let event_name = "eventTracker";
  let event_custom_name = "accessibility_icon";
  let extra_obj = {
    event_action: button,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_card_form_elements = (action) => {
  // if (typeof action === "string") action = action.toLowerCase();
  let event_name = "eventTracker";
  let event_custom_name = "checkout_payment_interaction";    
  let extra_obj = { 
    "payment_action_type": action
  };
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_login_succeeds = (method) => {
  let event_name = "eventTracker";
  let event_custom_name = "login_success";
  let extra_obj = {
    login_method : method
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_login_fails = (method) => {
  let event_name = "eventTracker";
  let event_custom_name = "login_faliure";
  let extra_obj = {
    login_method : method
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_login_form_inputs = (action,custom_event) => {
  let event_name = "eventTracker";
  let event_custom_name = custom_event;
  let extra_obj = {
    email_action_type: action,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_form_is_submitted_successfully = (name) => {
  let event_name = "eventTracker";
  let event_custom_name = "form_success_submit";
  let extra_obj = {
    form_name: name
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_form_is_success = (name) => {
  let event_name = "eventTracker";
  let event_custom_name = "form_success";
  let extra_obj = {
    form_name: name
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_account_is_created = () => {
  let event_name = "eventTracker";
  let event_custom_name = "account_creation";
  Tracking.custom_event(event_name, event_custom_name);
};

Events.when_user_clicks_on_promo_code_field = (action) => {
  let event_name = "eventTracker";
  let event_custom_name = "promocode";
  let extra_obj = {
    promo_action_type: action,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_interacts_with_logout_popup_buttons = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "logout_attempt";
  let extra_obj = {
    cta_name: label,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_when_user_clicks_on_non_resident_cta = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "resident_cta";
  let extra_obj = {
    cta_name: label,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_when_user_clicks_on_resident_cta = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "resident_cta";
  let extra_obj = {
    cta_name: label,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_non_resident_arrived_at_payment = () => {
  let event_name = "eventTracker";
  let event_custom_name = "non_resident_payment";
  Tracking.custom_event(event_name, event_custom_name);
};

Events.whe_user_clicks_on_newsletter_field = () => {
  let event_name = "eventTracker";
  let event_custom_name = "newsletter_action";
  Tracking.custom_event(event_name, event_custom_name);
};

Events.when_user_when_user_interacts_with_PIS_popup_buttons = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "pay_instore";
  let extra_obj = {
    cta_name: label,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_when_user_interacts_with_Pay_now_popup_buttons = (label) => {
  let is_resident = Storage.get("is_resident", true);
  let event_name = "eventTracker";
  let event_custom_name = is_resident === 'non_resident' ? "non_resident_online" : "pay_online";
  let extra_obj = {
    cta_name: label,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_when_user_interacts_with_POD_popup_buttons = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "order_continue";
  let extra_obj = {
    cta_action: label,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_when_user_interacts_with_POD_button_and_popup_buttons = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "pay_on_delivery";
  let extra_obj = {
    cta_name: label,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_non_resident_arrived_at_thank_you = () => {
  let event_name = "eventTracker";
  let event_custom_name = "non_resident_thankyou";
  Tracking.custom_event(event_name, event_custom_name);
};

Events.when_non_non_resident_collect_store_arrived_at_thank_you = () => {
  let event_name = "eventTracker";
  let event_custom_name = "non_resident_instore";
  Tracking.custom_event(event_name, event_custom_name);
};

Events.when_non_resident_paid_online_arrived_at_thank_you= () => {
  let event_name = "eventTracker";
  let event_custom_name = "non_resident_online";
  Tracking.custom_event(event_name, event_custom_name);
};
Events.when_user_clicks_on_summary_edit_plan = () => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: "edit plan",
    cta_type: "button",
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_summary_edit_number = () => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: "edit number",
    cta_type: "button",
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_go_to_mnp_link = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "link",
    cta_position : "bottom"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_number_shuffle = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "link",
    cta_position : "body"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};
Events.when_user_clicks_on_plans_country_rates = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "button",
    cta_position : "bottom"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};
Events.when_user_clicks_on_mnp_terms_edit_number = () => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: "mnp edit number",
    cta_type: "button",
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};
Events.when_user_clicks_on_under_18_modal_family_Plan_link = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "link",
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};
Events.when_user_clicks_on_non_resident_form_cta = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "button",
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_clicks_on_non_resident_form_store_link = (label) => {
  let event_name = "eventTracker";
  let event_custom_name = "click_cta";
  let extra_obj = {
    cta_name: label,
    cta_type: "link",
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};

Events.when_user_loads_page = () => {
  // let uid = Storage.get("customer_id", true) || '';
  let account_id = Storage.get("account_id", true) || '';
  let hash = window.location.hash.replace(/[#/]/g, '');
  let url = window.location.href;
  // virtually distinguish payment page views for analytics purposes:
  if (hash === 'payment'){
    hash = 'basket';
    url = url.replace('payment','basket');
  }
  let originalAppURL = Storage.get("originalAppURL");
  if (originalAppURL){
    url = originalAppURL.replace('plan-selection', hash);
  }
  
  let obj = {
    'event': 'virtualPageView',
    'pageUrl': url,
    'pageTitle': hash,
    'uid': account_id,
    'customer_status': Storage.get("account_id", true) ? 'logged in' : 'not logged in',
    'account_id': account_id,
    'registration_type': Storage.get("registration_type", true) ? (Storage.get("registration_type", true) === 'Email' ? 'email' : 'social') : '',
    'hashedEmail': Storage.get("hashed_email_address", true)? Storage.get("hashed_email_address", true) : '' // email id of user
  };
  Tracking.page_view_event(obj);
};

Events.when_page_view_changes = (pageTitle, url) => {
  let originalAppURL = Storage.get("originalAppURL");
  if (originalAppURL && url){
    url = url.replace(
      `${window.location.origin}${window.location.pathname}`,
      originalAppURL
    )
  }
  let account_id = Storage.get("account_id", true) || '';
  let obj = {
    'event': 'virtualPageView',
    'pageUrl': url,
    'pageTitle': pageTitle,
    'uid': account_id,
    'customer_status': Storage.get("account_id", true) ? 'logged in' : 'not logged in',
    'account_id': account_id,
    'registration_type': Storage.get("registration_type", true) ? (Storage.get("registration_type", true) === 'Email' ? 'email' : 'social') : '',
    'hashedEmail': Storage.get("hashed_email_address", true)? Storage.get("hashed_email_address", true) : '' // email id of user
  };
  Tracking.page_view_event(obj);
};

Events.when_user_clicks_on_a_affiliate_VMS_hyperlink = (action, product) => {
  let event_name = "eventTracker";
  let event_custom_name = "affiliate_wms";
  let extra_obj = {
    cta_name: `${action} - ${product}`,
    cta_type: "icon",
    cta_position : "top"
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};
Events.when_user_clicks_on_the_faq = (faq_topic, faq_category, faq_rating) => {
  let event_name = "eventTracker";
  let event_custom_name = "faq_action";
  let extra_obj = { 
    journey_name : "homepage",
    faq_topic,
    faq_category,
    faq_rating,
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}
Events.when_user_clicks_on_get_your_app_btn = (appName) => {
  let event_name = "eventTracker";
  let event_custom_name = "get your app";
  let extra_obj = {
    app_name: appName
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
};
Events.when_an_ab_test_is_shown = (variableName) => {
  if(window[variableName]){
    let experienceObj = Experiences[variableName]
    let obj = {
      event: "eventTracker",
      journey_name: "mobile plan",
      custom_event_name: 'active ab test',
      experience_name : experienceObj.experience_name,
      variant_name : window[variableName] === true ? experienceObj.variation_name : 'original',
    };
    Tracking.activeABTest(obj);
  }
}

Events.when_user_clicks_on_iphone_model = (model_name, plan_category) => {
  let event_name = "eventTracker";
  let event_custom_name = "choose_your_iphone";
  let extra_obj = { 
    journey_name : "mobile plans",
    sub_journey_name: `vip bundle - ${plan_category}`,
    model_name
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}

Events.when_user_clicks_on_device_details_link = (model_name, plan_category, type) => {
  let event_name = "eventTracker";
  let event_custom_name = type;
  let extra_obj = { 
    journey_name : "mobile plans",
    sub_journey_name: `vip bundle - ${plan_category}`,
    model_name
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}

Events.iphone_stock_availability = (product_name,plan_category,options) => {
  let inStock = ""
  let inStockList = options?.filter(c=>c.ExtraDetails?.Status === "1");
  if (inStockList){
    inStock = Object.values(inStockList).map(item=>item.ExtraDetails?.Colour).join(",");
  }
  let outOfStock = "";
  let outStockList = options?.filter(c=>c.ExtraDetails?.Status !== "1");
  if(outStockList){
    outOfStock = Object.values(outStockList).map(item=>item.ExtraDetails?.Colour).join(",");
  }

  let event_name = "eventTracker";
  let event_custom_name = "iphone_stock_avail";
  let extra_obj = { 
    journey_name : "mobile plans",
    sub_journey_name: `vip bundle - ${plan_category}`,
    product_name,
    instock_color: inStock,
    outstock_color: outOfStock
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}

Events.when_user_clicks_on_colour_selection = (model_name,plan_category,select_color) => {
  let event_name = "eventTracker";
  let event_custom_name = "iphone_select_color";
  let extra_obj = { 
    journey_name : "mobile plans",
    sub_journey_name: `vip bundle - ${plan_category}`,
    model_name,
    select_color
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}

Events.when_card_payment_fails = (error) => {
  let event_name = "eventTracker";
  let event_custom_name = "payment_error";
  let extra_obj = { 
    journey_name : "mobile plans",
    sub_journey_name: '',
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}
Events.when_user_interacts_with_sendBird = (custom_event_name) => {
  let plan = Storage.get('selected_plan', true);
  let event_name = "eventTracker";
  let event_custom_name = custom_event_name;
  let extra_obj = { 
    journey_name : "mobile plans",
    sub_journey_name: plan ? `${plan}` : '',
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}

Events.when_user_clicks_back_payment_methods = () => {
  let event_name = "eventTracker";
  let event_custom_name = "payment_methods_cancel";
  let extra_obj = { 
    journey_name : "mobile plans",
    cta_name: 'Back',
    cta_position: 'bottom',
    cta_type: 'button'
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}

Events.when_id_upload_fails_for_instalments = (failure_reason) => {
  let event_name = "eventTracker";
  let event_custom_name = 'id upload failure for instalments';
  let extra_obj = { 
    journey_name : "mobile plans",
    sub_journey_name: 'cashew instalments',
    failure_reason
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}

Events.when_user_chooses_upload_method_on_mobile = (scan_or_upload) => {
  let event_name = "eventTracker";
  let event_custom_name = 'instalment upload method';
  let extra_obj = { 
    journey_name : "mobile plans",
    sub_journey_name : 'cashew instalments',
    scan_or_upload
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}

Events.when_user_views_instalment_next_steps = () => {
  let event_name = "eventTracker";
  let event_custom_name = 'instalment next steps overlay';
  let extra_obj = { 
    journey_name : "mobile plans",
    sub_journey_name : 'cashew instalments',
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}

Events.when_user_uploads_or_scans_id_succeffully_for_instalments = (upload_or_scan = '') => {
  let event_name = "eventTracker";
  let event_custom_name = `instalment backside id successful ${upload_or_scan}`;
  let extra_obj = { 
    journey_name : "mobile plans",
    sub_journey_name : 'cashew instalments',
  }
  Tracking.custom_event(event_name, event_custom_name, extra_obj);
}
export default Events;

